import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'

export default class GigOfferChatMessage extends AbstractChatMessage {
  type = MessageTypes.GIG_OFFER
  budget?: string
  deadline?: number
  message: string
  timeType: number
  timeValue: number
  offerId: number
  stage: GigOfferStages
  isEscrowed: boolean

  constructor(data: LX.GigOfferChatMessage) {
    super(data)
    this.message = data.body.message
    this.body = data.body.message
    this.budget = data.body.rate
    this.deadline = data.body.deadline
    this.timeType = data.body.time_type
    this.timeValue = data.body.time_value
    this.offerId = data.entityId
    this.stage = data.body.stage
    this.isEscrowed = !!data.body.is_escrowed
  }

  static fromServer(data: LX.GigOfferChatMessage) {
    return new GigOfferChatMessage({ ...data, body: data.body })
  }

  getShortMessage() {
    return this.message
  }

  get deadlineInDays() {
    return (this.deadline || 0) / 86400
  }
}
